import { LandingContext } from 'common/contexts/Landing/Landing'
import { EColors } from 'common/styles'
import { Button } from 'components/buttons'
import { RowInfo } from 'components/RowInfo'
import { Styled } from 'components/Styled'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { StyledTitle } from './styled'
import { TWorkingTimeRestaurant } from 'models'
import { useGetRestaurants } from 'common/hooks/useGeRestaurants/useGeRestaurants'

const days: (keyof TWorkingTimeRestaurant)[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

export const Info = () => {
  const { t } = useTranslation()
  const { landing } = useContext(LandingContext)
  const language = localStorage.getItem('Localization') ?? 'uk'
  const { restaurant } = useGetRestaurants()

  const data = [
    {
      title: t('addresses'),
      Info: (
        <>
          <Styled.H3 color={EColors.primary_500}>
            {t('contact.address')}
          </Styled.H3>
        </>
      ),
    },
    {
      title: t('work.time'),
      Info: (
        <Styled.FlexWrapper direction="column" gap={16} align="flex-start">
          {days.map(day => (
            <Styled.H3 key={day} color={EColors.primary_500}>
              {t(`${day}`)} &nbsp;
              {restaurant?.workingTime[day].start} -{' '}
              {restaurant?.workingTime[day].end}
            </Styled.H3>
          ))}
        </Styled.FlexWrapper>
      ),
    },
    {
      title: t('phone'),
      Info: (
        <>
          <Styled.H3 color={EColors.primary_500}>
            {t('contact.phone')}
          </Styled.H3>
        </>
      ),
    },
    {
      title: t('social.media'),
      Info: (
        <>
          <Button.SocialMedia />
        </>
      ),
    },
  ]

  return (
    <>
      <Styled.FlexWrapper
        width="100%"
        direction="column"
        gap={28}
        style={{ marginTop: '48px' }}>
        {data.map((item, index) => (
          <RowInfo
            key={index}
            Info={item.Info}
            Title={<StyledTitle>{item.title}</StyledTitle>}
          />
        ))}
      </Styled.FlexWrapper>
    </>
  )
}
